import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "anchorRef", "value", "getItemDescription", "getItemDisabled", "getItemKey", "getItemLabel", "getItemLeftSide", "getItemAttributes", "items", "onChange", "className", "loading", "notFoundLabel", "multiple", "onClickOutside"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import { cnBem } from '@carnica/utils';
import { Popover } from "../../../modules/Popover";
import { ActionSheet } from "../../ActionSheet";
import styles from "./styles.pcss";
import { useSelectList } from "../hooks/useSelectList";
var cnSelectList = cnBem('select-list', styles);
var variants = {
  hidden: {
    poinerEvents: 'none',
    y: 12,
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1,
    poinerEvents: 'all'
  }
};
var SelectListRender = function SelectListRender(props, ref) {
  var isOpen = props.isOpen,
    anchorRef = props.anchorRef,
    valueProp = props.value,
    getItemDescription = props.getItemDescription,
    getItemDisabled = props.getItemDisabled,
    getItemKey = props.getItemKey,
    getItemLabel = props.getItemLabel,
    getItemLeftSide = props.getItemLeftSide,
    getItemAttributesProp = props.getItemAttributes,
    _props$items = props.items,
    itemsProp = _props$items === void 0 ? [] : _props$items,
    onChange = props.onChange,
    className = props.className,
    loading = props.loading,
    notFoundLabel = props.notFoundLabel,
    multiple = props.multiple,
    onClickOutside = props.onClickOutside,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useSelectList = useSelectList({
      getItemDisabled: getItemDisabled,
      isOpen: isOpen,
      getItemKey: getItemKey,
      value: valueProp,
      items: itemsProp,
      onChange: onChange,
      multiple: multiple,
      onClickOutside: onClickOutside
    }),
    getItemActive = _useSelectList.getItemActive,
    onItemClick = _useSelectList.onItemClick,
    items = _useSelectList.items;
  var getItemAttributes = useCallback(function (item) {
    var attributes = getItemAttributesProp(item) || {};
    return _objectSpread(_objectSpread({}, attributes), {}, {
      className: cnSelectList('item', [attributes.className])
    });
  }, [getItemAttributesProp]);
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: isOpen,
    initial: false,
    mode: "wait",
    onExitComplete: function onExitComplete() {
      return null;
    },
    "data-t-id": "Select-SelectList"
  }, isOpen && /*#__PURE__*/React.createElement(Popover, _extends({}, otherProps, {
    anchorRef: anchorRef,
    animate: "visible",
    className: cnSelectList(null, [className]),
    direction: "downStartLeft",
    equalAnchorWidth: true,
    exit: "hidden",
    initial: "hidden",
    motion: true,
    offsetVertical: 8,
    onClickOutside: onClickOutside,
    possibleDirections: ['downStartLeft', 'upStartLeft'],
    ref: ref,
    reposition: true,
    transition: {
      transform: {
        duration: 0.3
      },
      opacity: {
        duration: 0.3
      }
    },
    variants: variants
  }), /*#__PURE__*/React.createElement(ActionSheet, {
    className: cnSelectList('list'),
    getItemAttributes: getItemAttributes,
    getItemChecked: getItemActive,
    getItemDescription: getItemDescription,
    getItemDisabled: getItemDisabled,
    getItemKey: getItemKey,
    getItemLabel: getItemLabel,
    getItemLeftSide: getItemLeftSide,
    getItemOnClick: onItemClick,
    items: items,
    loading: loading,
    multiple: multiple,
    notFoundLabel: notFoundLabel,
    renderListAsMotion: true,
    role: "listbox",
    "data-t-id": "Select-SelectList"
  })));
};
export var SelectList = /*#__PURE__*/forwardRef(SelectListRender);